/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy scoring is available from the 2023 season onwards.`)
};

const es_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La puntuación fantasy está disponible desde la temporada 2023.`)
};

const de_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Punkte sind ab der Saison 2023 verfügbar.`)
};

const nl_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-scoring is beschikbaar vanaf het seizoen 2023.`)
};

const fr_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La notation fantasy est disponible à partir de la saison 2023.`)
};

const it_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il punteggio fantasy è disponibile dalla stagione 2023 in poi.`)
};

const pt_br2_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pontuação fantasy está disponível a partir da temporada 2023.`)
};

const pt_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pontuação fantasy está disponível a partir da época 2023.`)
};

const ja_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジースコアは2023年シーズンから利用可能です。`)
};

const zh_f1_standings_no_fantasy_before_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻评分从2023赛季起可用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_no_fantasy_before_2023 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_no_fantasy_before_2023(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_no_fantasy_before_2023", locale)
	if (locale === "en") return en_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "es") return es_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "de") return de_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "nl") return nl_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "fr") return fr_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "it") return it_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "pt") return pt_f1_standings_no_fantasy_before_2023(inputs)
	if (locale === "ja") return ja_f1_standings_no_fantasy_before_2023(inputs)
	return zh_f1_standings_no_fantasy_before_2023(inputs)
};